import React from 'react';
import BreadcrumbsDi, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import {
	useObjectSchemaId,
	useObjectSchemaName,
	useObjectStoreState,
} from '@atlassian/jira-servicedesk-insight-object-details-store/src/controllers/store/index.tsx';
import {
	toCmdbObjectTypeId,
	toSchemaId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
// eslint-disable-next-line jira/styled/no-styled-import-alias
import { Skeleton as SkeletonCell } from '@atlassian/jira-servicedesk-insight-shared-ui/src/ui/skeleton/styled.tsx';
import {
	createObjectDetailUrl,
	createObjectSchemaUrl,
	createObjectTypeUrl,
} from '@atlassian/jira-servicedesk-insight-urls/src/index.tsx';
import { Link } from '@atlassian/react-resource-router';

export type Props = {
	showFullTrail: boolean;
};

export const Breadcrumbs = (props: Props) => {
	const [{ objectDetails }] = useObjectStoreState();
	const [objectSchemaId] = useObjectSchemaId();
	const [objectSchemaName] = useObjectSchemaName();

	if (!objectDetails || objectSchemaId == null || objectSchemaName == null) {
		return <BreadcrumbsSkeleton />;
	}

	return (
		<BreadcrumbsDi>
			{props.showFullTrail && (
				<>
					<BreadcrumbsItem
						href={createObjectSchemaUrl(toSchemaId(objectSchemaId))}
						text={objectSchemaName}
						component={Link}
					/>
					<BreadcrumbsItem
						href={createObjectTypeUrl(
							toSchemaId(objectSchemaId),
							toCmdbObjectTypeId(objectDetails.objectType.id),
						)}
						text={objectDetails.objectType.name}
						component={Link}
					/>
				</>
			)}
			<BreadcrumbsItem
				href={createObjectDetailUrl(objectDetails.id)}
				text={objectDetails.objectKey}
				component={Link}
			/>
		</BreadcrumbsDi>
	);
};

export const BreadcrumbsSkeleton = () => <SkeletonCell margin="0" width="100px" height="24px" />;
